import QuestionDetail from './QuestionDetail';

export default QuestionDetail;
